import React from 'react'

//component
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable'
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton'
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector'
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput'
import NotificationBar from  '@/components/elements/languages/NotificationBar'
import AddUsersToGroupModal from  '@/components/modals/orgSettings/userGroups/addNewGroup/AddUsersToGroupModal'

//hooks
import UseUserGroupsUsersTabs, {IUseUserGroupsUsersTabs} from './UserGroupsUsersTab.hooks'

//styling
import "../../../../css/orgSettings/userGroups/usersGroupsUserTab.scss"

interface IUserGroupsUsersTabButtonPanelContent {
    isExternalGroup: boolean,
    groupCanBeModified: boolean,
    hookValues: IUseUserGroupsUsersTabs
}

const UserGroupsUsersTabButtonPanelContent = ({isExternalGroup, groupCanBeModified, hookValues}: IUserGroupsUsersTabButtonPanelContent ) => {

    const {
        addUsersToGroupButtonText,
        addUsersToGroupButtonLabel,
        onShowAddUsersToGroupModal,
        bulkAddUsersButtonText,
        bulkAddUsersButtonLabel,
        onBulkAddUsersClick,
        createNewUserButtonText,
        createNewUserButtonLabel,
        onCreateNewUserClick
    } = hookValues

    if (groupCanBeModified) {
        return <>
            <BasicButton content={addUsersToGroupButtonText} ariaLabel={addUsersToGroupButtonLabel} onButtonClick={onShowAddUsersToGroupModal} />
            <BasicButton content={bulkAddUsersButtonText} ariaLabel={bulkAddUsersButtonLabel} onButtonClick={onBulkAddUsersClick} />
        </>
    }

    return isExternalGroup
        ? <></>
        : <BasicButton content={createNewUserButtonText} ariaLabel={createNewUserButtonLabel} onButtonClick={onCreateNewUserClick}/>
}

const UserGroupsUsersTab = ({isExternalGroup}: {isExternalGroup: boolean}) => {

    const userGroupsUserHookValues =  UseUserGroupsUsersTabs();

    const {
        searchInputLabel,
        noDataMessage,
        notificationDetails,
        paginationSettings,
        setSearchString,
        searchString,
        tableContent,
        showSimpleTable,
        getNewPage,
        isLoading,
        showAddUsersToGroupModal,
        onHideAddUsersToGroupModal,
        groupCanBeModified
    } = userGroupsUserHookValues

    return(
        <div className="user-groups-users-tab" data-testid="user-groups-user-tab">
            <div className='user-top-button-panel'> 
                <SimpleSearchInput ariaLabel={searchInputLabel} setSearchString={setSearchString} searchString={searchString} />
            </div>

            {showSimpleTable && <SimpleTable isLoading={isLoading} simpleTableContent={tableContent} noDataMessage={noDataMessage} maxContentLength={20} isInfiniteScroll={false} />}
            
            {paginationSettings?.hasPagination &&  <SimplePageSelector currentPage={paginationSettings.currentPage} totalPages={paginationSettings.totalPages} setPage={getNewPage} />}
            
            {!isLoading && 
                <div className='user-button-panel'>
                    <UserGroupsUsersTabButtonPanelContent
                        isExternalGroup={isExternalGroup}
                        groupCanBeModified={groupCanBeModified}
                        hookValues={userGroupsUserHookValues}
                    />
                </div>
            }

            <AddUsersToGroupModal showModal={showAddUsersToGroupModal} hideModal={onHideAddUsersToGroupModal}/>
            <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
        </div>
    )
}

export default UserGroupsUsersTab